import Actions               from 'Redux/Actions';
import { InvoiceRepository } from 'Domain/Repositories';
import { ofType }            from 'redux-observable';
import { from, EMPTY }       from 'rxjs';
import { mergeMap }          from 'rxjs/operators';
import { TEpic }             from 'Redux/Config';

export const findInvoiceEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findInvoiceRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        InvoiceRepository.findById(id)
          .then((invoice) => Actions.findInvoiceSuccess({ invoice }))
          .catch(error => Actions.findInvoiceFailure({ error })),
      );
    }),
  );
};
